import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  getHasta, getHastalar, yeniHasta, guncelleHasta,
  getUlkeler, getGelisTuru, getIller, getIlceler,
} from '../services/api';
import API from '../services/api';

const KAN_GRUPLARI = ['0 Rh ( + )', '0 Rh ( - )', 'A Rh ( + )', 'A Rh ( - )', 'B Rh ( + )', 'B Rh ( - )', 'AB Rh ( + )', 'AB Rh ( - )'];
const EGITIMLER = ['Bilinmiyor', 'İlkokul', 'Ortaokul', 'Lise', 'Önlisans', 'Lisans', 'Yüksek Lisans', 'Doktora'];
const MEDENI = [{ k: '?', a: 'Bilinmiyor' }, { k: 'B', a: 'Bekar' }, { k: 'E', a: 'Evli' }, { k: 'D', a: 'Dul' }];

const bosForm = {
  hesapAdi: '', uyruk: '9980', kimlikKaynak: 'tc', kimlikNo: '',
  dogumYeri: '', dogTar: '', anneAdi: '', babaAdi: '', kanGrubu: '?',
  medeniHali: '?', cinsiyet: 'E', egitim: 'Bilinmiyor', kvkk: false, dur: false,
  gelisTuru: '', adres: '', sehir: '', ilce: '', tel: '', cepTel: '', eposta: '', ozelNotlar: '',
};

// Etiket + zorunlu yıldızı
function Lbl({ children, zorunlu }) {
  return (
    <div className="form-label">
      {zorunlu && <span className="zorunlu-nokta" />}
      {children}
    </div>
  );
}

export default function HastaForm() {
  const { kayitNo } = useParams();
  const duzenleme = !!kayitNo;
  const navigate = useNavigate();

  const [f, setF] = useState(bosForm);
  const [ulkeler, setUlkeler] = useState([]);
  const [gelisTurleri, setGelisTurleri] = useState([]);
  const [iller, setIller] = useState([]);
  const [ilceler, setIlceler] = useState([]);
  const [z, setZ] = useState({});       // zorunluluk bayrakları
  const [hata, setHata] = useState('');
  const [kaydediyor, setKaydediyor] = useState(false);
  const [yukleniyor, setYukleniyor] = useState(true);

  const turk = f.uyruk === '9980';
  const deg = (k, v) => setF(p => ({ ...p, [k]: v }));

  // Seçili il adına göre ilçeleri yükle
  const ilceleriYukle = useCallback((ilAdi, illerListesi) => {
    const il = (illerListesi || []).find(i => i.ad === ilAdi);
    if (!il) { setIlceler([]); return Promise.resolve([]); }
    return getIlceler(il.id).then(r => { setIlceler(r.data); return r.data; }).catch(() => { setIlceler([]); return []; });
  }, []);

  // İlk yükleme: lookuplar + zorunlular + (düzenleme ise) hasta
  useEffect(() => {
    let iptal = false;
    Promise.all([
      getUlkeler(), getGelisTuru(), getIller(), API.get('/Lookup/zorunlular'),
    ]).then(async ([u, g, il, zr]) => {
      if (iptal) return;
      setUlkeler(u.data); setGelisTurleri(g.data); setIller(il.data); setZ(zr.data);

      if (duzenleme) {
        const { data: h } = await getHasta(kayitNo);
        if (iptal) return;
        const yeni = {
          hesapAdi: h.hesapAdi || '',
          uyruk: h.uyrukKod || '9980',
          kimlikKaynak: h.kimlikKaynak || 'tc',
          kimlikNo: h.kimlikNo || '',
          dogumYeri: h.dogumYeri || '',
          dogTar: h.dogTar ? h.dogTar.substring(0, 10) : '',
          anneAdi: (h.anneAdi || '').trim(),
          babaAdi: (h.babaAdi || '').trim(),
          kanGrubu: h.kanGrubu || '?',
          medeniHali: h.medeniKod || '?',
          cinsiyet: h.cinsiyet === 'K' ? 'K' : 'E',
          egitim: h.egitim || 'Bilinmiyor',
          kvkk: !!h.kvkkImzali,
          dur: !!h.dur,
          gelisTuru: h.gelisTuru || '',
          adres: h.adres || '',
          sehir: h.sehir || '',
          ilce: h.ilce || '',
          tel: (h.tel || '').replace(/\D/g, '').length >= 7 ? h.tel : '',
          cepTel: (h.cepTel || '').replace(/\D/g, '').length >= 7 ? h.cepTel : '',
          eposta: h.eposta || '',
          ozelNotlar: (h.ozelNotlar || '').trim(),
        };
        setF(yeni);
        if (yeni.sehir) await ilceleriYukle(yeni.sehir, il.data);
      }
      setYukleniyor(false);
    }).catch(() => { if (!iptal) { setHata('Form verileri yüklenemedi.'); setYukleniyor(false); } });
    return () => { iptal = true; };
  }, [kayitNo, duzenleme, ilceleriYukle]);

  const uyrukDegis = (kod) => {
    setF(p => ({ ...p, uyruk: kod, kimlikKaynak: kod === '9980' ? 'tc' : (p.kimlikKaynak === 'tc' ? 'pasaport' : p.kimlikKaynak) }));
  };

  const sehirDegis = (ad) => {
    setF(p => ({ ...p, sehir: ad, ilce: '' }));
    ilceleriYukle(ad, iller);
  };

  // Doğrulama (VB6 mantığı + ZORUNLULAR)
  const dogrula = () => {
    const ad = f.hesapAdi.trim();
    if (!f.uyruk) return 'Lütfen hastanın UYRUĞUNU belirtiniz.';
    if (!ad) return 'Hastanın Adını Yazmadan Kayıt Yapamazsınız.';
    if (/\s{2,}/.test(f.hesapAdi)) return 'Ad ve soyad arasında çift boşluk kullanmayınız.';
    if (!f.dogTar) return 'Hastanın doğum tarihini yazınız.';

    const dt = new Date(f.dogTar);
    if (new Date().getFullYear() - dt.getFullYear() > 150) return 'Hastanın yaşında sorun var!';
    if (dt > new Date()) return 'Doğum tarihi bugünden büyük olamaz.';

    if (z.tcKimlik && !f.kimlikNo.trim() && f.kimlikKaynak !== 'hicbiri')
      return 'TC Kimlik / Pasaport / Yabancı Kimlik numarası zorunludur.';
    if (z.dogYer && !f.dogumYeri.trim()) return 'DOĞUM YERİ zorunludur.';
    if (z.kanGrubu && (!f.kanGrubu || f.kanGrubu === '?')) return 'KAN GRUBU zorunludur.';
    if (z.gelisTuru && !f.gelisTuru) return 'GELİŞ TÜRÜ zorunludur.';
    if (z.anne && !f.anneAdi.trim()) return 'ANNE ADI zorunludur.';
    if (z.baba && !f.babaAdi.trim()) return 'BABA ADI zorunludur.';
    if (z.medeni && (!f.medeniHali || f.medeniHali === '?')) return 'MEDENİ HALİ zorunludur.';
    if (z.egitim && (!f.egitim || f.egitim === 'Bilinmiyor')) return 'EĞİTİM zorunludur.';
    if (z.adres && f.adres.trim().length < 5) return 'ADRES zorunludur.';
    if (z.sehirIlce && (!f.sehir || !f.ilce)) return 'İL ve İLÇE zorunludur.';
    const onbirHane = (v) => (v || '').replace(/\D/g, '').length === 11;
    if (z.telefon && !onbirHane(f.tel) && !onbirHane(f.cepTel)) return 'Ev veya Cep telefonundan en az birini 11 hane olarak giriniz.';
    if (z.eposta && !f.eposta.trim()) return 'E-MAİL zorunludur.';
    return '';
  };

  const kaydet = async (e) => {
    e.preventDefault();
    setHata('');
    const h = dogrula();
    if (h) { setHata(h); window.scrollTo(0, 0); return; }

    // Aynı isimli hasta var mı? (yumuşak uyarı)
    try {
      const { data: liste } = await getHastalar(f.hesapAdi.trim());
      const ayni = liste.find(p => (p.hesapAdi || '').trim().toLocaleUpperCase('tr') === f.hesapAdi.trim().toLocaleUpperCase('tr') && String(p.kayitNo) !== String(kayitNo));
      if (ayni && !window.confirm(`Aynı isimli hasta kaydı mevcut (No: ${ayni.kayitNo}). Yine de devam edilsin mi?`)) return;
    } catch { /* arama başarısızsa engelleme */ }

    const dto = { ...f };
    setKaydediyor(true);
    try {
      const res = duzenleme ? await guncelleHasta(kayitNo, dto) : await yeniHasta(dto);
      navigate(`/hasta/${res.data.kayitNo}`);
    } catch (err) {
      const m = err?.response?.data?.mesaj || 'Kayıt sırasında bir hata oluştu.';
      setHata(m); window.scrollTo(0, 0);
    } finally {
      setKaydediyor(false);
    }
  };

  if (yukleniyor) return <div className="kart kart-pad">Yükleniyor…</div>;

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <span onClick={() => navigate(duzenleme ? `/hasta/${kayitNo}` : '/hastalar')}
              style={{ color: 'var(--mor)', cursor: 'pointer', fontSize: 13.5, fontWeight: 600 }}>
          ← Vazgeç
        </span>
      </div>

      <h1 className="sayfa-baslik">{duzenleme ? 'Hasta Bilgilerini Düzenle' : 'Yeni Hasta Kaydı'}</h1>
      <p className="sayfa-alt">Zorunlu alanlar <span className="zorunlu-nokta" style={{ display: 'inline-block', verticalAlign: 'middle' }} /> ile işaretlidir.</p>

      {hata && <div className="hata-box">{hata}</div>}

      <form onSubmit={kaydet}>
        {/* Kimlik */}
        <div className="kart kart-pad" style={{ marginBottom: 18 }}>
          <div className="bolum-baslik">🪪 Kimlik Bilgileri</div>
          <div className="form-grid">
            <div className="form-row">
              <Lbl zorunlu>Uyruk</Lbl>
              <select className="input" value={f.uyruk} onChange={e => uyrukDegis(e.target.value)}>
                {ulkeler.map(u => <option key={u.kod} value={u.kod}>{u.ad}</option>)}
              </select>
            </div>

            <div className="form-row">
              <Lbl zorunlu={!!z.tcKimlik}>{turk ? 'TC Kimlik No' : 'Kimlik / Pasaport No'}</Lbl>
              <input className="input" value={f.kimlikNo} disabled={!turk && f.kimlikKaynak === 'hicbiri'}
                     onChange={e => deg('kimlikNo', e.target.value)} placeholder={turk ? '11 haneli TC No' : ''} />
            </div>

            {!turk && (
              <div className="form-row genis">
                <Lbl>Yabancı Kimlik Türü</Lbl>
                <div className="radio-grup">
                  {[{ v: 'pasaport', a: 'Pasaport' }, { v: 'yabanci', a: 'Yabancı Kimlik' }, { v: 'hicbiri', a: 'Hiçbiri' }].map(o => (
                    <label key={o.v}>
                      <input type="radio" name="kk" checked={f.kimlikKaynak === o.v}
                             onChange={() => deg('kimlikKaynak', o.v)} /> {o.a}
                    </label>
                  ))}
                </div>
              </div>
            )}

            <div className="form-row genis">
              <Lbl zorunlu>Adı - Soyadı</Lbl>
              <input className="input" value={f.hesapAdi} onChange={e => deg('hesapAdi', e.target.value)} placeholder="Ad Soyad" />
            </div>

            <div className="form-row">
              <Lbl zorunlu={!!z.dogYer}>Doğum Yeri</Lbl>
              <input className="input" value={f.dogumYeri} onChange={e => deg('dogumYeri', e.target.value)} />
            </div>
            <div className="form-row">
              <Lbl zorunlu>Doğum Tarihi</Lbl>
              <input type="date" className="input" value={f.dogTar} onChange={e => deg('dogTar', e.target.value)} />
            </div>
            <div className="form-row">
              <Lbl zorunlu={!!z.anne}>Anne Adı</Lbl>
              <input className="input" value={f.anneAdi} onChange={e => deg('anneAdi', e.target.value)} />
            </div>
            <div className="form-row">
              <Lbl zorunlu={!!z.baba}>Baba Adı</Lbl>
              <input className="input" value={f.babaAdi} onChange={e => deg('babaAdi', e.target.value)} />
            </div>
            <div className="form-row">
              <Lbl zorunlu={!!z.kanGrubu}>Kan Grubu</Lbl>
              <select className="input" value={f.kanGrubu} onChange={e => deg('kanGrubu', e.target.value)}>
                <option value="?">Bilinmiyor</option>
                {KAN_GRUPLARI.map(k => <option key={k} value={k}>{k}</option>)}
              </select>
            </div>
            <div className="form-row">
              <Lbl zorunlu={!!z.medeni}>Medeni Hali</Lbl>
              <select className="input" value={f.medeniHali} onChange={e => deg('medeniHali', e.target.value)}>
                {MEDENI.map(m => <option key={m.k} value={m.k}>{m.a}</option>)}
              </select>
            </div>
            <div className="form-row">
              <Lbl zorunlu>Cinsiyet</Lbl>
              <select className="input" value={f.cinsiyet} onChange={e => deg('cinsiyet', e.target.value)}>
                <option value="E">Erkek</option>
                <option value="K">Kadın</option>
              </select>
            </div>
            <div className="form-row">
              <Lbl zorunlu={!!z.egitim}>Eğitim</Lbl>
              <select className="input" value={f.egitim} onChange={e => deg('egitim', e.target.value)}>
                {EGITIMLER.map(eg => <option key={eg} value={eg}>{eg}</option>)}
              </select>
            </div>
            <div className="form-row">
              <Lbl zorunlu={!!z.gelisTuru}>Geliş Türü</Lbl>
              <select className="input" value={f.gelisTuru} onChange={e => deg('gelisTuru', e.target.value)}>
                <option value="">Seçiniz</option>
                {gelisTurleri.map(g => <option key={g.ad} value={g.ad}>{g.ad}</option>)}
              </select>
            </div>
            <div className="form-row">
              <Lbl>KVKK Sözleşmesi</Lbl>
              <select className="input" value={f.kvkk ? '1' : '0'} onChange={e => deg('kvkk', e.target.value === '1')}>
                <option value="0">İmzalanmadı</option>
                <option value="1">İmzalandı</option>
              </select>
            </div>
          </div>
        </div>

        {/* İletişim & Adres */}
        <div className="kart kart-pad" style={{ marginBottom: 18 }}>
          <div className="bolum-baslik">📍 İletişim & Adres</div>
          <div className="form-grid">
            <div className="form-row">
              <Lbl zorunlu={!!z.sehirIlce}>Şehir</Lbl>
              <select className="input" value={f.sehir} onChange={e => sehirDegis(e.target.value)}>
                <option value="">Seçiniz</option>
                {iller.map(i => <option key={i.id} value={i.ad}>{i.ad}</option>)}
              </select>
            </div>
            <div className="form-row">
              <Lbl zorunlu={!!z.sehirIlce}>İlçe</Lbl>
              <select className="input" value={f.ilce} onChange={e => deg('ilce', e.target.value)} disabled={!f.sehir}>
                <option value="">Seçiniz</option>
                {ilceler.map(i => <option key={i.id} value={i.ad}>{i.ad}</option>)}
              </select>
            </div>
            <div className="form-row">
              <Lbl zorunlu={!!z.telefon}>Cep Telefonu</Lbl>
              <input className="input" value={f.cepTel} onChange={e => deg('cepTel', e.target.value)} placeholder="0-5xx-xxx-xx-xx" />
            </div>
            <div className="form-row">
              <Lbl zorunlu={!!z.telefon}>Sabit Telefon</Lbl>
              <input className="input" value={f.tel} onChange={e => deg('tel', e.target.value)} placeholder="0-xxx-xxx-xx-xx" />
            </div>
            <div className="form-row">
              <Lbl zorunlu={!!z.eposta}>E-Posta</Lbl>
              <input className="input" value={f.eposta} onChange={e => deg('eposta', e.target.value)} />
            </div>
            <div className="form-row genis">
              <Lbl zorunlu={!!z.adres}>Adres</Lbl>
              <textarea className="input" value={f.adres} onChange={e => deg('adres', e.target.value)} />
            </div>
          </div>
        </div>

        {/* Özel Notlar */}
        <div className="kart kart-pad" style={{ marginBottom: 18 }}>
          <div className="bolum-baslik">📝 Özel Notlar</div>
          <textarea className="input" value={f.ozelNotlar} onChange={e => deg('ozelNotlar', e.target.value)} />
          <label className="onay-satir" style={{ marginTop: 14 }}>
            <input type="checkbox" checked={f.dur} onChange={e => deg('dur', e.target.checked)} />
            👑 VIP Hasta
          </label>
        </div>

        <div style={{ display: 'flex', gap: 12 }}>
          <button type="submit" className="btn" disabled={kaydediyor}>
            {kaydediyor ? 'Kaydediliyor…' : (duzenleme ? '💾 Güncelle' : '💾 Kaydet')}
          </button>
          <button type="button" className="btn-ikincil" onClick={() => navigate(duzenleme ? `/hasta/${kayitNo}` : '/hastalar')}>
            Vazgeç
          </button>
        </div>
      </form>
    </div>
  );
}
